import React from 'react';
import { ClipboardCheck, FileBarChart, Layers } from 'lucide-react';

import { getPublicImageSrc } from '../utils/publicAssets';
import { cn } from '../utils/cn';

const WORKFLOW_STEPS = [
  { icon: Layers, label: 'Map capabilities' },
  { icon: ClipboardCheck, label: 'Run assessments' },
  { icon: FileBarChart, label: 'Review reports' },
] as const;

export type ProjectGateVisualPanelProps = {
  className?: string;
};

/**
 * Left column on the project gate — full-height illustration and workspace copy.
 */
export function ProjectGateVisualPanel({ className }: ProjectGateVisualPanelProps) {
  const radarSrc = getPublicImageSrc('RadarGrid.svg');

  return (
    <aside className={cn('ps-gate__visual', className)} aria-hidden="true">
      <div className="ps-gate__visual-surface">
        <div className="ps-gate__visual-glow" aria-hidden />
        <div className="ps-gate__visual-inner">
          <div className="ps-gate__visual-art" aria-hidden>
            <img
              className="ps-gate__visual-radar"
              src={radarSrc}
              alt=""
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="ps-gate__visual-copy">
            <p className="ps-gate__visual-eyebrow">Your workspace</p>
            <p className="ps-gate__visual-title app-heading-accent">
              Assess, align, and improve
            </p>
            <p className="ps-gate__visual-text">
              Each project brings together capabilities, assessments, and expert
              feedback in one place.
            </p>

            <ul className="ps-gate__visual-steps">
              {WORKFLOW_STEPS.map((step) => {
                const Icon = step.icon;
                return (
                  <li key={step.label}>
                    <span className="ps-gate__visual-step-icon">
                      <Icon size={16} strokeWidth={1.75} aria-hidden />
                    </span>
                    <span>{step.label}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default ProjectGateVisualPanel;
